import * as React from 'react';
import axios from 'axios';
import { Country } from '@bb/domain/dist/types';
import { ListingLabelContextType } from 'contexts';
import { UserRoles } from '@bb/users';
import SearchContainer from './SearchContainer';
import ListingsContainer from './ListingsContainer';

type Listing = any;

interface Props {
  role?: UserRoles;
  headerText: string;
  selected?: string;
  onListingSelected: (listing: Listing) => any;
  isFromCountry: (country: Country) => boolean;
  labelOverrideMap: ListingLabelContextType['labelOverrideMap'];
}

interface State {
  searchParams?: {};
  listings?: Listing[];
  count?: number;
  page: number;
  limit?: number;
}

class SelectListingComponent extends React.Component<Props, State> {
  state: State = {
    page: 0,
  };

  searchType = (role: UserRoles) => {
    let _searchType;
    switch (role) {
      case UserRoles['Team Admin']:
        _searchType = 'team';
        break;
      case UserRoles.Agent:
        _searchType = 'user';
        break;
      default:
        _searchType = 'brokerage';
    }
    return _searchType;
  };

  fetchListings = async () => {
    const { data } = await axios.get(
      `/listing/${this.searchType(this.props.role)}/${this.state.page}`,
      {
        withCredentials: true,
        params: this.state.searchParams,
      },
    );
    this.setState(data);
  };

  search = (params: any) =>
    this.setState(
      prev => ({ ...prev, searchParams: params }),
      this.fetchListings,
    );

  setPage = (page: number) => {
    const { count, limit } = this.state;
    const last = Math.ceil(count / limit) - 1;
    if (page < 0) return;
    if (page > last) return;
    if (page === this.state.page) return;
    this.setState(prev => ({ ...prev, page }), this.fetchListings);
  };

  render() {
    const {
      selected,
      headerText,
      onListingSelected,
      isFromCountry,
      labelOverrideMap,
    } = this.props;
    const { listings, page, count, limit } = this.state;
    return (
      <div>
        <SearchContainer
          search={this.search}
          isFromCountry={isFromCountry}
          labelOverrideMap={labelOverrideMap}
        >
          <h3>{headerText}</h3>
        </SearchContainer>
        {this.state.listings !== undefined && (
          <ListingsContainer
            viewPage={this.setPage}
            listings={listings}
            page={page}
            count={count}
            limit={limit}
            selected={selected}
            select={onListingSelected}
          />
        )}
      </div>
    );
  }
}

export default SelectListingComponent;
